
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","viewBox":"0 0 374 374","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M289.5 234.5L259 244l-14.5-8.5V86L275 76l14.5 10v148.5z","fill":"#fff"}}),_c('path',{attrs:{"d":"M289.5 86L259 95m30.5-9v148.5L259 244m30.5-158L275 76l-30.5 10m14.5 9v149m0-149l-14.5-9M259 244l-14.5-8.5V86","stroke":"#232122","stroke-width":"2"}}),_c('path',{attrs:{"d":"M187 268.995L156 279.5l-18-10.505V126.936l31.5-10.436 17.5 11.43v141.065z","fill":"#fff"}}),_c('path',{attrs:{"d":"M187 127.93l-31 9.939m31-9.939v141.065L156 279.5m31-151.57l-17.5-11.43-31.5 10.436m18 10.933V279.5m0-141.631l-18-10.933M156 279.5l-18-10.505V126.936","stroke":"#232122","stroke-width":"2"}}),_c('path',{attrs:{"d":"M239 251l-31 10.223L191.5 252V145.5l31-10.5 16.5 12.5V251z","fill":"#fff"}}),_c('path',{attrs:{"d":"M239 147.5l-31 9.5m31-9.5V251l-31 10.223M239 147.5L222.5 135l-31 10.5M208 157v104.223M208 157l-16.5-11.5M208 261.223L191.5 252V145.5","stroke":"#232122","stroke-width":"2"}}),_c('path',{attrs:{"d":"M132 287l-31 10.5L85 287v-89.5l32-9 15 11V287z","fill":"#fff"}}),_c('path',{attrs:{"d":"M132 199.5l-31 9m31-9V287l-31 10.5m31-98l-15-11-32 9m16 11v89m0-89l-16-11m16 100L85 287v-89.5","stroke":"#232122","stroke-width":"2"}})])
          )
        }
      }
    